/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I've made some video games:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://store.steampowered.com/app/2660180/MEANWHILE_IN_SECTOR_80/"
        }}><strong parentName="a">{`MEANWHILE IN SECTOR 80`}</strong></a>{` (unreleased, Steam)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://lpghatguy.itch.io/shanty-of-the-stallion"
        }}><strong parentName="a">{`Shanty of the Stallion`}</strong></a>{` (2025, itch.io)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://lpghatguy.itch.io/zombie-demo-game"
        }}><strong parentName="a">{`ZOMBIE DEMO GAME`}</strong></a>{` (2023, itch.io)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://lpghatguy.itch.io/depth-first-search-ld48"
        }}><strong parentName="a">{`Depth-First Search`}</strong></a>{` (2023, itch.io, Ludum Dare #48)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://lpghatguy.itch.io/ludum-dare-29-whac-a-something"
        }}><strong parentName="a">{`Whac-A-Something!`}</strong></a>{` (2014, itch.io, Ludum Dare #29)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://lpghatguy.itch.io/ludum-dare-28-warrior"
        }}><strong parentName="a">{`Warrior`}</strong></a>{` (2013, itch.io, Ludum Dare #28)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://lpghatguy.itch.io/ludum-dare-27-fast-food"
        }}><strong parentName="a">{`:Fast :Food`}</strong></a>{` (2013, itch.io, Ludum Dare #27)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://lpghatguy.itch.io/ludum-dare-26-john"
        }}><strong parentName="a">{`JOHN`}</strong></a>{` (2013, itch.io, Ludum Dare #26)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://lpghatguy.itch.io/ludum-dare-25-london-bridges"
        }}><strong parentName="a">{`London Bridges`}</strong></a>{` (2012, itch.io, Ludum Dare #25)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://lpghatguy.itch.io/ld24-unbound"
        }}><strong parentName="a">{`UNBOUND`}</strong></a>{` (2012, itch.io, Ludum Dare #24)`}</li>
    </ul>
    <p>{`I've worked at a few neat places:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://secondhalf.games"
        }}><strong parentName="a">{`Second Half Games`}</strong></a>{` (2022—current) on `}<a parentName="li" {...{
          "href": "https://store.steampowered.com/app/2660180/MEANWHILE_IN_SECTOR_80/"
        }}>{`MEANWHILE IN SECTOR 80`}</a>{` (wishlist now!)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://uplift.games"
        }}><strong parentName="a">{`Uplift Games`}</strong></a>{` (2020—2021) on the hit game `}<a parentName="li" {...{
          "href": "https://playadopt.me"
        }}>{`Adopt Me!`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.roblox.com"
        }}><strong parentName="a">{`Roblox`}</strong></a>{` (2017—2020) where I created projects like `}<a parentName="li" {...{
          "href": "https://github.com/Roblox/roact"
        }}>{`Roact`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.geckodesigns.com"
        }}><strong parentName="a">{`Gecko Designs`}</strong></a>{` (2015—2017) on pilot websites for some major brands`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://univisioncomputers.com"
        }}><strong parentName="a">{`Univision Computers`}</strong></a>{` (2011—2014) where I got my start!`}</li>
    </ul>
    <p>{`I'm the creator of `}<a parentName="p" {...{
        "href": "https://github.com/rojo-rbx/rojo"
      }}>{`Rojo`}</a>{` and its related projects.`}</p>
    <p>{`I've been working in the Rust game development ecosystem. I maintain some libraries in that space:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/LPGhatguy/yakui"
        }}>{`yakui`}</a>{`, a declarative UI library for games that bridges the gap between prototype and production-quality UI`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/LPGhatguy/thunderdome"
        }}>{`Thunderdome`}</a>{`, an efficient generational arena`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/SecondHalfGames/jolt-rust"
        }}>{`jolt-rust`}</a>{` and `}<a parentName="li" {...{
          "href": "https://github.com/SecondHalfGames/JoltC/"
        }}>{`JoltC`}</a>{`, bindings to the Jolt physics engine`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/LPGhatguy/crevice"
        }}>{`Crevice`}</a>{`, a library that aids laying out data for use in shaders`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
